// component compatible with antd Form.Item
import React from "react"
import ActivityListItem from "../ActivityListItem/ActivityListItem"

// types
import type { ActivityType } from "../../assessment-types"
import type { PayloadCreate } from "../LinkActivitiesModal"

type CreateActivityItemProps = {
  value?: PayloadCreate
  onChange?: (value: PayloadCreate) => void
  remove: () => void
  activityTypes: ActivityType[]
  createProjects: PayloadCreate[]
  disabled?: boolean
}

const CreateActivityItem = ({
  value,
  onChange,
  remove,
  activityTypes,
  createProjects,
  disabled,
}: CreateActivityItemProps) => {
  const getCreateActivityTitle = (id: number): string =>
    activityTypes.find((type: ActivityType) => type.id === id)?.title || ""

  const getCreateActivityName = (id: number): string | null =>
    createProjects.find((create: PayloadCreate) => create.project_type_id === id)?.name || null

  const handleChangeName = (name: string | null) => {
    if (onChange && value) {
      onChange({
        project_type_id: value.project_type_id,
        should_complete: value.should_complete,
        name: name || null,
      })
    }
  }

  const handleComplete = (shouldComplete: boolean) => {
    if (onChange && value)
      onChange({
        project_type_id: value.project_type_id,
        should_complete: shouldComplete,
        name: value.name,
      })
  }

  if (!value) return null

  return (
    <ActivityListItem
      key={value.project_type_id}
      type="new"
      id={value.project_type_id}
      title={getCreateActivityTitle(value.project_type_id)}
      status="New"
      onRemove={() => remove()}
      name={getCreateActivityName(value.project_type_id)}
      onSetName={handleChangeName}
      isCompleted={value.should_complete}
      onComplete={handleComplete}
      disabled={disabled}
    />
  )
}

export default CreateActivityItem
